namespace Slick {
    export interface Column {
        summaryType?: Serenity.SummaryType;
    }
}

namespace Serenity {
    export interface CustomSummaryMixinOptions {
        grid: Serenity.DataGrid<any, any>;
        aggregate?: AggregateCallback;
        summaryTypeChange?: (column: Slick.Column) => void;
    }

    export type AggregateCallback = (field: string, summaryType: SummaryType, totals: Slick.GroupTotals<any>) => void;

    function toAggregator(field: string, summaryType: SummaryType, aggregate: AggregateCallback) {
        if (!aggregate) {
            switch (summaryType) {
                case SummaryType.Sum: return new Slick.Aggregators.Sum(field);
                case SummaryType.Avg: return new Slick.Aggregators.Avg(field);
                case SummaryType.Max: return new Slick.Aggregators.Max(field);
                case SummaryType.Min: return new Slick.Aggregators.Min(field);
            }
        }
        else {
            switch (summaryType) {
                case SummaryType.Sum:
                case SummaryType.Avg:
                case SummaryType.Max:
                case SummaryType.Min:
                    return new CustomAggregator(field, summaryType, aggregate)
            }
        }
        return null;
    }

    function CustomAggregator(field: string, summaryType: SummaryType, aggregate: AggregateCallback) {
        this.field_ = field;
        this.summaryType_ = summaryType;
        this.init = function () {
        };
        this.accumulate = function (item) {
        };
        this.storeResult = function (groupTotals) {
            aggregate(this.field_, this.summaryType_, groupTotals);
        };
    }

    export class CustomSummaryMixin {
        
        constructor(options: CustomSummaryMixinOptions) {
            var dg = options.grid;

            var getDefaultAggregators = () => {
                var columns = dg['allColumns'];
                var aggregators: any[] = [];
                for (var x of columns) {
                    
                    if (x.sourceItem == null)
                        continue;
               
                    if (x.sourceItem.summaryType != null &&
                        x.sourceItem.summaryType != SummaryType.Disabled) {

                        var aggregator = toAggregator(x.field,
                            x.sourceItem.summaryType, options.aggregate);
                        if (aggregator == null)
                            continue;
                        x.summaryType = x.sourceItem.summaryType;
                        aggregators.push(aggregator);
                    }
                }

                return aggregators;
            };

            dg.view.setSummaryOptions({
                aggregators: getDefaultAggregators(),
                totals: null
            } as any);

            var aggregatesPopup = $(`<ul class="s-AggregatesPopup" 
                style="display:none;position:absolute;z-index:100000;">
                <li data-agg="1">Sum</li>
                <li data-agg="2">Average</li>
                <li data-agg="3">Min</li>
                <li data-agg="4">Max</li>
                <li>None</li>
            </ul>`).appendTo(document.body)
                .click(e => {
                    if (!$(e.target).is("li"))
                          return;

                    var col = aggregatesPopup.data("column") as Slick.Column;
                    if (col == null || !col.id)
                        return;

                    var column = Q.tryFirst(dg['allColumns'] as Slick.Column[], x => x.id == col.id);
                    if (!column)
                        return;

                    if (column.sourceItem == null ||
                        column.sourceItem.summaryType == SummaryType.Disabled)
                        return;

                    var agg = Q.toId($(e.target).data('agg'));
                    if (agg === column.summaryType)
                        return;

                    column.summaryType = agg;

                    var aggregators = dg['allColumns']
                        .filter(x => x.summaryType)
                        .map(x => toAggregator(x.field, x.summaryType, options.aggregate))
                        .filter(x => x != null);

                    dg.view.setSummaryOptions({
                        aggregators: aggregators,
                        totals: null
                    } as any);

                    var grouping = (dg.view as any).getGrouping();
                    for (var i = 0; i < grouping.length; i++)
                        grouping[i].aggregators = aggregators;

                    dg.view.setGrouping(grouping);
                    dg.slickGrid.invalidate();

                    if (options.summaryTypeChange)
                        options.summaryTypeChange(column);
                });

            dg.element.on('click', '.slick-footerrow-column', e => {              
                e.preventDefault();

                var col = $(e.currentTarget).data('column');
                if (!col || !col.id)
                    return;

                var column = Q.tryFirst(dg['allColumns'] as Slick.Column[], x => x.id == col.id);
                if (!column)
                    return;

                if (!column ||
                    !column.sourceItem ||
                    column.sourceItem.summaryType == SummaryType.Disabled)
                    return;

                aggregatesPopup.data('column', column)
                    .show()
                    .css('top', (e.pageY - aggregatesPopup.height()) + 'px')
                    .css('left', e.pageX + 'px')
                    .children('li')
                    .removeClass('active')
                    .end()
                    .children('li[data-agg=' + column.summaryType + ']')
                    .addClass('active');

                $(document.body).off('click.aggregatesMenu' + dg['uniqueName']);

                window.setTimeout(() => $(document.body)
                    .on("click.aggregatesMenu" + dg['uniqueName'], () => {
                        aggregatesPopup.hide();
                        $(document.body).off('click.aggregatesMenu' + dg['uniqueName']);
                    }), 1);
            });

            var oldCurrentSettings = (dg as any).getCurrentSettings;
            (dg as any).getCurrentSettings = function (flags: GridPersistanceFlags) {
                var settings = oldCurrentSettings.apply(dg, [flags]);
                return settings;
            };

            var oldRestoreSettings = (dg as any).restoreSettings;
            (dg as any).restoreSettings = function (settings?: PersistedGridSettings, 
                flags?: GridPersistanceFlags) {
                oldRestoreSettings.apply(dg, [settings, flags]);
            };
        }
    }
}